import { Grid, IconButton, Typography } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useIntl} from 'react-intl';
import MenuIcon from '@mui/icons-material/Menu';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { useState } from "react";

const CustomTablePagingInfo = (props) => {
    const intl = useIntl();

    const [selected, setSelected] = useState(3);

    const buttons = [
      { id: 1, icon: <HorizontalRuleIcon /> },
      { id: 2, icon: <DragHandleIcon /> },
      { id: 3, icon: <MenuIcon /> },
    ];

    return (
      <Grid container sx={{ mt: 0.5 }} id="pagingInfo">
        <Grid item sm={props.isSearchTable ? 7 : 9}>
          <Typography
            variant="subtitle1"
            sx={{ fontSize: 20, mt: 0.5 }}
            className="apeDarkGreyColor"
          >
            {intl.formatMessage({ id: "General.SearchResults" })}:{" "}
            {props.totalCount}
          </Typography>
        </Grid>
        <Grid item sm={2}>
          <Typography
            variant="subtitle1"
            sx={{ fontSize: 20, mt: 0.5 }}
            className="apeDarkGreyColor"
          >
            {intl.formatMessage({ id: "General.Page" })} {props.page}{" "}
            {intl.formatMessage({ id: "General.Of" })} {props.maxPage}
          </Typography>
        </Grid>
        <Grid item sm={0.5}>
          <IconButton
            color="inherit"
            className="apeBlueColor"
            onClick={props.handlePreviousPage}
          >
            <ArrowBackIosIcon />
          </IconButton>
        </Grid>
        <Grid item sm={0.5}>
          <IconButton
            color="inherit"
            className="apeBlueColor"
            onClick={props.handleNextPage}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Grid>
        {props.isSearchTable ? (
          <Grid item sm={2} textAlign="end">
            {buttons.map(({ id, icon }) => (
              <IconButton
                key={id}
                color="inherit"
                className={
                  selected === id ? "apeBlueColorClicked" : "apeBlueColor"
                }
                onClick={() => {
                  setSelected(id);
                  props.rowsToDisplay(id);
                }}
              >
                {icon}
              </IconButton>
            ))}
          </Grid>
        ) : null}
      </Grid>
    );
}

export default CustomTablePagingInfo;